"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useForceUpdate() {
    var updating = react_1.useRef(false);
    var timer = react_1.useRef(null);
    var _a = react_1.useState(Object.create(null)), dispatch = _a[1];
    updating.current = true;
    var memoizedDispatch = react_1.useCallback(function () {
        if (!updating.current)
            dispatch(Object.create(null));
        else {
            clearTimeout(timer.current);
            timer.current = setTimeout(function () {
                dispatch(Object.create(null));
            });
        }
    }, [dispatch]);
    react_1.useEffect(function () {
        updating.current = false;
    });
    return memoizedDispatch;
}
exports.useForceUpdate = useForceUpdate;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react/lib/hooks/useForceUpdate.js
// module id = 545
// module chunks = 0